import {Chart} from 'angular-highcharts';
import {Component} from '@angular/core';
import {TenantsCommunityDatasDTO} from '@rsp/models/dto/tenants-community-data.dto';
import {BaseChartComponent} from '@rsp/shared/component/graph/base-chart.component';
import * as Highcharts from 'highcharts';
import {SeriesLineOptions} from 'highcharts';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';


@Component({
  selector: 'rsp-community-erzeugung-verbrauch-chart',
  templateUrl: '../base-chart.component.html',
})

export class CommunityErzeugungVerbrauchChartComponent extends BaseChartComponent<TenantsCommunityDatasDTO> {
  constructor(private userTracker: UserTrackingService) {
    super();
  }

  render() {
    super.render();

    const {consumption, production} = this.transform(this._data);

    const options: Highcharts.Options = this.createChartOptions();

    (<SeriesLineOptions>options.series[0]).data = production;
    (<SeriesLineOptions>options.series[1]).data = consumption;

    options.exporting.enabled = this._enableExport;

    this.chart = new Chart(options);

  }

  protected createChartOptions(): Highcharts.Options {
    return {
      chart: {
        type: 'line',
        animation: {
          duration: 1000
        },
        zoomType: 'x',
      },
      exporting: {
        enabled: false,
      },
      series: [{
        name: 'Erzeugung',
        type: 'line',
        data: [],
        color: this.color1,
        events: {
          hide: (e) => {
            this.userTracker.trackEvent('Community Erzeugung / Verbrauch Diagramm', 'Ausblenden', (<HTMLInputElement>e.target).name);
          },
          show: (e) => {
            this.userTracker.trackEvent('Community Erzeugung / Verbrauch Diagramm', 'Einblenden', (<HTMLInputElement>e.target).name);
          }
        }
      }, {
        name: 'Verbrauch',
        type: 'line',
        data: [],
        color: this.color2
      }],
      xAxis: {
        type: 'datetime',
        crosshair: true,
        events: {
          afterSetExtremes: (e) => {
            this.userTracker.trackEvent('Community Erzeugung / Verbrauch Diagramm', 'Zoom');
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          format: '{value} kW'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      plotOptions: {},
      tooltip: {
        shared: true,
        pointFormatter: function () {
          return BaseChartComponent.pointFormatter(this, 'kW');
        }
      },
    };
  }

  private transform(data: TenantsCommunityDatasDTO): { consumption: any[], production: any[] } {
    const provided = [];
    const consumption = [];

    for (let i = 0, l = data.values.length; i < l; i++) {
      const dateTime = new Date(data.values[i].timestamp).getTime();

      for (let j = 0; j < data.values[i].consumptionSums.length; j++) {
        if (data.values[i].consumptionSums[j]) {

          const projectedDateTime = dateTime + j * 900 * 1000;

          provided.push([projectedDateTime, data.values[i].productionSums[j]]);
          consumption.push([projectedDateTime, data.values[i].consumptionSums[j]]);
        }
      }

    }

    return {
      consumption: consumption,
      production: provided,
    };
  }
}
